import { Component, OnInit, Inject, ViewChild, ElementRef, HostListener } from '@angular/core';
import { FormArray, FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import swal from 'sweetalert2';
import { IncidenciasService } from '../../incidencias.service';
import { Incidencias } from 'src/app/shared/model/incidencias/incidencia.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { incidenciaDetalleQABean } from 'src/app/shared/model/security/incidenciaDetalleQABean.model';
import { EtapaProyectoBean } from 'src/app/shared/model/incidencias/etapaproyecto.model';
import { VersionBean } from 'src/app/shared/model/incidencias/version.model';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { MensajesFijosEnum } from 'src/app/utilerias/enums/mensajes-fijos-enum';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import { MatError, MatFormField, MatHint, MatInput, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import {
  LIMITE_PORQUE,
  preguntaPorque,
  quitarPrefijoPorque,
  ResolucionEstructurada,
} from '../resolucion-causa-origen.util';
import { NOMBRE_PENDIENTE, rechazoDelGuardado } from '../../resolucion-version.util';

/** Marca el porqué en cuanto se escribe de más, sin esperar a que pierda el foco. */
const ERROR_AL_ESCRIBIR: ErrorStateMatcher = {
  isErrorState: (control) => !!control && control.invalid && (control.dirty || control.touched),
};

/**
 * T3b: «Marcar resuelto» sin selector de versión (la incidencia es trazable y
 * la bandera está encendida). Lo que dice la tarjeta «Versión donde se
 * resolvió»; la resolución queda «Pendiente de versión» y la entrega el
 * servidor en la siguiente versión QA de la etapa (plan §5.6, D3).
 */
export interface ResolucionSinSelector {
  /** «la próxima versión QA de Migración». */
  seEntregaraEn: string;
  /** «V3-13-08-2026 (aquí se detectó)» o «Sin versión vigente». */
  versionVigente: string;
}

@Component({
    selector: 'app-comentariosDesarrollo',
    templateUrl: './comentariosDesarrollo.component.html',
    styleUrls: ['./comentariosDesarrollo.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, NgIf, MatFormField, MatLabel, MatHint, MatError, MatSelect, NgFor, MatOption, MatInput, MatSelectionList, MatListOption, MatButton]
})
export class ComentariosDesarrolloComponent implements OnInit {

  readonly limitePorque = LIMITE_PORQUE;
  readonly errorAlEscribir = ERROR_AL_ESCRIBIR;

  formRegistro: FormGroup;
  bean: Incidencias = new Incidencias();
  status: string;
  version: string
  listaversion: Array<VersionBean>;
  descripcion: string;
  selectedVersion: string;
  tituloVersion: string;
  totalsize = 0;
  evidencia = [];
  selectedOptions = [];
  index: number;
  btnElimina: boolean = true;
  btnAgrega: boolean = false;
  etapaProyectoBean = new EtapaProyectoBean();
  visto: boolean;
  oculto: boolean;
  esComentario: boolean = false;
  resolucionExpandida = false;
  causaOrigenExpandida = true;
  errorPorques = '';
  readonly nombrePendiente = NOMBRE_PENDIENTE;
  /** T3b: con la tarjeta, sin selector; null = el selector de siempre. */
  sinSelector: ResolucionSinSelector | null = null;

 @ViewChild('nameFile') nameFile: ElementRef;
 @ViewChild('versionSelect') versionSelect: MatSelect;
  constructor(public dialogRef: MatDialogRef<ComentariosDesarrolloComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private incidenciasService: IncidenciasService, private formBuilder: FormBuilder) { }

  ngOnInit() {
    switch (this.data.titulo) {
      case 'Agregar comentario': {
        this.status = this.data.dataKey.estatus;
        this.oculto = true;
        this.esComentario = true;
        break;
      }
      case 'Observacion': {
        this.status = Constantes.OBSERVACIONES;
        this.oculto = true;
        break;
      }
      case 'Proceso': {
        this.status = Constantes.PROCESO;
        this.oculto = true;
        break;
      }
      case 'Resuelto': {
        this.status = Constantes.RESUELTO;
        this.visto = true;
        this.sinSelector = this.data.sinSelector ?? null;
        break;
      }
    }

    this.etapaProyectoBean.id_proyecto_etapa = this.data.idProyecto;
    this.etapaProyectoBean.id_etapa = this.data.idEtapa;
    if (this.data.version != null && this.data.version != undefined) {
          this.tituloVersion = this.data.version.nombre;
    }
    if (this.sinSelector) {
      this.tituloVersion = NOMBRE_PENDIENTE;
    }
    if (this.data.listaVersiones != null && this.data.listaVersiones != undefined) {
      this.listaversion = this.visto
        ? this.data.listaVersiones.filter((version) => this.esVersionResolucionValida(version?.id))
        : this.data.listaVersiones;
    }

    this.formreg();
    if (this.esResolucionDesdeProceso && this.data.resolucionPrevia) {
      this.cargarResolucionPrevia(this.data.resolucionPrevia as ResolucionEstructurada);
    }
  }


  detalle: incidenciaDetalleQABean = new incidenciaDetalleQABean();
  onSave() {
    this.errorPorques = '';
    if (this.esResolucionDesdeProceso && !this.validarPorquesResolucion()) {
      this.causaOrigenExpandida = true;
      this.porquesResolucion.markAllAsTouched();
      return;
    }

    if (!this.formRegistro.valid) {
      if (this.formRegistro.get('descripcion')?.invalid) {
        this.resolucionExpandida = true;
      }
      swal.fire({
        text: MensajesFijosEnum.INCIDENCIA_DATOS_VACIOS,
        buttonsStyling: false,
        customClass:{
          confirmButton: 'btn btn-danger',
        },
        icon: 'error'
      });
      return;
    }

    const versionSeleccionada = this.formRegistro.value.version;
    if (this.conSelector && !this.esVersionResolucionValida(versionSeleccionada)) {
      this.mostrarAlertaVersionNoValida();
      return;
    }

    this.bean.id_version_incidencia = this.visto
      ? versionSeleccionada
      : versionSeleccionada ||
        this.data.version?.id ||
        this.data.version;
    if (this.sinSelector) {
      // T3b: la versión va vacía; el servidor pone el centinela.
      this.bean.id_version_incidencia = '';
    }

    this.bean.descincidencia = this.formRegistro.value.descripcion;
    this.bean.porquesResolucion = this.esResolucionDesdeProceso
      ? this.obtenerPorquesResolucion()
      : [];
    this.bean.estatus = this.status;
    this.bean.id = this.data.dataKey.id
    this.bean.id_proyecto = this.data.dataKey.id_proyecto;
    this.bean.fecha_creacion = this.data.dataKey.fecha_creacion;
    this.bean.id_incidencia_proyecto = this.data.dataKey.id_incidencia_proyecto;
    this.bean.id_usuario_desarrollo = this.data.dataKey.id_usuario_desarrollo;
    this.bean.id_usuario_qa = this.data.dataKey.id_usuario_qa;

    if (this.esComentario) {
      this.bean.esComentario = Constantes.UNO;
    } else {
      this.bean.esComentario = Constantes.CERO;
    }
    this.incidenciasService.guardaComentario(this.bean).subscribe({
      next: (incidencia) => {
        // Un rechazo (VAL-*) o una respuesta vacía no se pintan como éxito.
        const rechazo = rechazoDelGuardado(incidencia);
        if (rechazo) {
          this.avisaRechazo(rechazo);
          return;
        }
        if (this.evidencia.length > 0) {
          const formData = new FormData();
          for (let i = 0; i < this.evidencia.length; i++) {
            formData.append('file', this.evidencia[i],  "INCIDENCIA" + "$" + "QA" + "$" + incidencia.id + "$" + incidencia.detalleBean.id + "$" + incidencia.id_proyecto + "$" + this.evidencia[i].name);
          }
          console.log(formData.getAll('file'));            
          this.incidenciasService.uploadEvidencia(formData).subscribe();
        }
        swal.fire({
          text: MensajesFijosEnum.INCIDENCIA_EXITOSA,
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success',
          },
          icon: 'success',
   
        }).then(() => {
          this.dialogRef.close(incidencia as Incidencias);
        })
      },
      error: (error) => {
        swal.fire({
          text: this.obtenerMensajeError(error),
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-danger",
          },
          icon: "error",
        });
      },
    });
  }

  private avisaRechazo(texto: string): void {
    swal.fire({
      text: texto,
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-danger",
      },
      icon: "error",
    });
  }

  private obtenerMensajeError(error: any): string {
    const respuesta = error?.error;
    return (
      respuesta?.mensaje ||
      respuesta?.message ||
      (typeof respuesta === "string" ? respuesta : null) ||
      "No fue posible guardar la resolución. Verifique los datos e inténtelo nuevamente."
    );
  }

  private esVersionResolucionValida(versionId: unknown): boolean {
    // La reportada en el alta, la misma que valida el backend; sin ella, la de antes.
    const idVersionReportada =
      this.data.versionReportada !== undefined
        ? this.data.versionReportada
        : this.data.version?.id ?? this.data.version;
    return (
      versionId !== null &&
      versionId !== undefined &&
      versionId !== "" &&
      idVersionReportada !== null &&
      idVersionReportada !== undefined &&
      idVersionReportada !== "" &&
      String(versionId) !== String(idVersionReportada)
    );
  }

  private mostrarAlertaVersionNoValida(): void {
    swal.fire({
      text:
        "No se cuenta con una versión válida para marcar como resuelto. Registra una nueva versión del proyecto e inténtalo nuevamente.",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-danger",
      },
      icon: "error",
    });
  }

  formreg() {
    this.formRegistro = this.formBuilder.group({
      descripcion: ['', [Validators.required]],
      version: [''],
      evidenciasSeleccionadas: [[]],
      porquesResolucion: this.formBuilder.array(
        Array.from({ length: 5 }, (_value, index) => this.crearPorqueControl(index)),
      ),
    });
  
    if (this.conSelector) {
      this.formRegistro.controls.version.setValidators([Validators.required]);
    } else {
      this.formRegistro.controls.version.clearValidators();
    }
  
    this.formRegistro.controls.version.updateValueAndValidity();
  }

  /** «Marcar resuelto» con el selector de versión de siempre (sin T3b). */
  get conSelector(): boolean {
    return !!this.visto && !this.sinSelector;
  }

  get esResolucionDesdeProceso(): boolean {
    return this.visto && this.data?.dataKey?.estatus === 'PROCESO';
  }

  get porquesResolucion(): FormArray {
    return this.formRegistro.get('porquesResolucion') as FormArray;
  }

  agregarPorque(): void {
    this.porquesResolucion.push(this.crearPorqueControl(this.porquesResolucion.length));
    this.causaOrigenExpandida = true;
  }

  eliminarPorque(index: number): void {
    if (index >= 5 && index < this.porquesResolucion.length) {
      this.porquesResolucion.removeAt(index);
    }
  }

  preguntaPorque(index: number): string {
    return preguntaPorque(this.obtenerPorquesResolucion(), index);
  }

  abrirInformacionCausaOrigen(): void {
    swal.fire({
      title: 'Causa / Origen',
      text: 'Capture los cinco porqués en orden. Puede agregar más cuando sea necesario para explicar la causa raíz.',
      icon: 'info',
    });
  }

  /** Caracteres que lleva la respuesta, para el contador n/100. */
  largoPorque(index: number): number {
    return String(this.porquesResolucion.at(index)?.value ?? '').length;
  }

  private crearPorqueControl(index: number) {
    const validadores = [Validators.maxLength(LIMITE_PORQUE)];
    if (this.esResolucionDesdeProceso && index < 5) {
      validadores.unshift(Validators.required);
    }
    return this.formBuilder.control('', validadores);
  }

  /**
   * Una resolución anterior puede traer respuestas de más de 100 caracteres:
   * se marcan desde que abre el diálogo, en vez de enterarse al guardar con un
   * "No se permite dejar campos vacíos".
   */
  private cargarResolucionPrevia(resolucionPrevia: ResolucionEstructurada): void {
    this.formRegistro.patchValue({ descripcion: resolucionPrevia.resolucion });
    this.porquesResolucion.clear();
    resolucionPrevia.causas.forEach((causa, index) => {
      this.porquesResolucion.push(
        this.crearPorqueControl(index),
      );
      this.porquesResolucion.at(index).setValue(quitarPrefijoPorque(causa.respuesta));
    });
    this.porquesResolucion.markAllAsTouched();
    this.errorPorques = this.mensajePorquesExcedidos() ?? '';
  }

  private obtenerPorquesResolucion(): string[] {
    return this.porquesResolucion.controls.map((control) => String(control.value || '').trim());
  }

  /** Qué respuestas pasan del límite, para decirlo con número; null si ninguna. */
  private mensajePorquesExcedidos(): string | null {
    const excedidas = this.porquesResolucion.controls
      .map((_control, index) => ({ numero: index + 1, largo: this.largoPorque(index) }))
      .filter(({ largo }) => largo > LIMITE_PORQUE);

    if (excedidas.length === 0) {
      return null;
    }
    if (excedidas.length === 1) {
      const [{ numero, largo }] = excedidas;
      return `La respuesta ${numero} tiene ${largo} caracteres; el máximo es ${LIMITE_PORQUE}. Acórtela para guardar.`;
    }
    const numeros = excedidas.map(({ numero }) => numero);
    const lista = `${numeros.slice(0, -1).join(', ')} y ${numeros[numeros.length - 1]}`;
    return `Las respuestas ${lista} pasan de ${LIMITE_PORQUE} caracteres. Acórtelas para guardar.`;
  }

  private validarPorquesResolucion(): boolean {
    const excedidas = this.mensajePorquesExcedidos();
    if (excedidas) {
      this.errorPorques = excedidas;
      return false;
    }

    const porques = this.obtenerPorquesResolucion();
    const ultimoConContenido = porques.reduce(
      (ultimo, porque, index) => (porque ? index : ultimo),
      -1,
    );

    if (ultimoConContenido < 4) {
      this.errorPorques = 'Capture los primeros 5 porqués para marcar la incidencia como resuelta.';
      return false;
    }

    for (let index = 0; index <= ultimoConContenido; index++) {
      if (!porques[index]) {
        this.errorPorques = 'Los porqués deben capturarse en orden, sin saltos.';
        return false;
      }
    }
    return true;
  }
  

  subirEv() {

    const input = (<HTMLInputElement>document.getElementById('nameFile'));
    if (input.files.length > 0) {
      for (let i = 0; i <= input.files.length - 1; i++) {
        this.totalsize = this.totalsize + input.files.item(i).size;
        this.evidencia.push(input.files[i]);
      }
    }
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";

  }

  onNgModelChange(): void {
    const seleccionadas = this.formRegistro.get('evidenciasSeleccionadas')?.value || [];
    this.selectedOptions = seleccionadas;
  
    this.btnElimina = seleccionadas.length === 0;
    this.btnAgrega = seleccionadas.length > 0;
  }
  
  elimina(): void {
    const seleccionadas = this.formRegistro.get('evidenciasSeleccionadas')?.value || [];
  
    for (const item of seleccionadas) {
      const index = this.evidencia.findIndex(e => e.name === item.name);
      if (index > -1) {
        this.evidencia.splice(index, 1);
      }
    }
  
    this.formRegistro.get('evidenciasSeleccionadas')?.setValue([]);
    this.selectedOptions = [];
    this.onNgModelChange();
  }
  

  onCloseClick() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  @HostListener('document:pointerdown', ['$event'])
  cerrarSelectorVersionAlHacerClicFuera(event: PointerEvent): void {
    if (!this.versionSelect?.panelOpen) {
      return;
    }

    const objetivo = event.target as HTMLElement | null;
    if (
      objetivo?.closest('.incidencia-desarrollo-version-select-panel') ||
      objetivo?.closest('.mat-mdc-select-trigger')
    ) {
      return;
    }

    this.versionSelect.close();
  }

}
